import { render, staticRenderFns } from "./Friend.vue?vue&type=template&id=31c871f2&scoped=true"
import script from "./Friend.vue?vue&type=script&lang=js"
export * from "./Friend.vue?vue&type=script&lang=js"
import style0 from "./Friend.vue?vue&type=style&index=0&id=31c871f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c871f2",
  null
  
)

export default component.exports